import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Option } from 'components/ItemPicker/FilterSelectMenu';
function TeamTypeFilter(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    teamTypes = _ref.teamTypes;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Select, {
    label: t('actions_filter'),
    value: value,
    onChange: onChange
  }, /*#__PURE__*/React.createElement(Option, {
    value: ""
  }, value ? t('actions_reset_filter') : t('actions_filter_by_type')), teamTypes.map(function (type) {
    return /*#__PURE__*/React.createElement(Option, {
      key: type.id,
      value: type.id
    }, type.name);
  }));
}
export default TeamTypeFilter;